import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white"
}
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "table content-table" }
const _hoisted_7 = {
  class: "avatar rounded bg-light-company",
  style: {"width":"55px","height":"55px","display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "font-weight-bold" }
const _hoisted_10 = { class: "small text-muted" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { "aria-label": "Page navigation" }
const _hoisted_13 = { class: "pagination justify-content-center" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.perms && _ctx.perms.stock && _ctx.perms.stock == 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "card-title fw-bold mb-0" }, "Statistiques du stock", -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-9" }, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                id: "ingredients",
                "aria-controls": "intedient-list",
                style: {"margin-bottom":"22px"},
                class: "btn btn-primary mr-0 mr-sm-1 buttons",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.FilterData && _ctx.FilterData(...args)))
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "flaticon-search" }, null, -1)
              ])),
              _createElementVNode("button", {
                style: {"margin-bottom":"22px"},
                class: "btn btn-danger mr-0 mr-sm-1 buttons",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ClearFilterData && _ctx.ClearFilterData(...args)))
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "flaticon-close" }, null, -1)
              ]))
            ]),
            (!_ctx.display)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("table", _hoisted_6, [
                      _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Image"),
                          _createElementVNode("th", null, "RÉFÉRENCE VARIANTE"),
                          _createElementVNode("th", null, "PRODUITS"),
                          _createElementVNode("th", null, "COLIS"),
                          _createElementVNode("th", null, "COLIS LIVRÉS")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (post, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("img", {
                                  style: {"height":"70px","width":"70px"},
                                  src: 
                          post && post.product_pic
                            ? post.product_pic
                            : require('@/assets/images/NoImage.png')
                        ,
                                  alt: post && post.var_name ? post.var_name : 'No Name'
                                }, null, 8, _hoisted_8)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(post && post.inventory_ref ? post.inventory_ref : "N/A"), 1),
                              _createElementVNode("div", _hoisted_10, _toDisplayString(post && post.var_name ? post.var_name : "N/A"), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(post && post.var_name ? post.var_name : "N/A"), 1),
                            _createElementVNode("td", null, _toDisplayString(post && post.total !== undefined ? post.total : 0), 1),
                            _createElementVNode("td", null, _toDisplayString(post &&
                      (post.DELIVERED !== undefined
                        ? post.DELIVERED
                        : post.delivered !== undefined
                        ? post.delivered
                        : 0)) + " Colis Livrés ", 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("nav", _hoisted_12, [
                      _createElementVNode("ul", _hoisted_13, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: _ctx.users.current_page === 1 }])
                        }, [
                          _createElementVNode("button", {
                            class: "page-link",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePage(_ctx.users.current_page - 1))),
                            disabled: _ctx.users.current_page === 1
                          }, " Précedent ", 8, _hoisted_14)
                        ], 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users.last_page, (page) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: page,
                            class: _normalizeClass(["page-item", { active: _ctx.users.current_page === page }])
                          }, [
                            _createElementVNode("button", {
                              class: "page-link",
                              onClick: ($event: any) => (_ctx.changePage(page))
                            }, _toDisplayString(page), 9, _hoisted_15)
                          ], 2))
                        }), 128)),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: _ctx.users.current_page === _ctx.users.last_page }])
                        }, [
                          _createElementVNode("button", {
                            class: "page-link",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePage(_ctx.users.current_page + 1))),
                            disabled: _ctx.users.current_page === _ctx.users.last_page
                          }, " Suivant ", 8, _hoisted_16)
                        ], 2)
                      ])
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}